import * as React from 'react';
import { CarouselSlideRenderControlProps, CarouselCellAlignProp } from 'nuka-carousel';
import styled from 'styled-components';
import { is } from '@packages/ui';

const ListUl = styled.ul`
  position: relative;
  white-space: nowrap;
  padding: 0;
  margin: 0 -20px;
  top: 0;
`;

const ListLi = styled.li`
  list-style-type: none;
  display: inline-block;
  padding: 0 20px;
`;

const Button: any = styled.button`
  background: transparent;
  border: 2px solid #d5d0cc;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: block;
  padding: 0;
  margin: 0;

  ${is('active')`
    background: #d5d0cc;
  `};
`;

export interface PagingDotsProps extends CarouselSlideRenderControlProps {
  cellAlign: CarouselCellAlignProp;
  className: string;
}

export class PagingDots extends React.Component<PagingDotsProps> {
  getDotIndexes(slideCount: number, slidesToScroll: number, slidesToShow: number, cellAlign: CarouselCellAlignProp) {
    const dotIndexes = [];
    let lastDotIndex = slideCount - slidesToShow;

    switch (cellAlign) {
      case 'center':
      case 'right':
        lastDotIndex += slidesToShow - 1;
        break;
    }
    if (lastDotIndex < 0) {
      return [0];
    }

    for (let i = 0; i < lastDotIndex; i += slidesToScroll) {
      dotIndexes.push(i);
    }
    dotIndexes.push(lastDotIndex);
    return dotIndexes;
  }

  goToSlide = (index: number) => () => {
    const { goToSlide } = this.props;
    goToSlide(index);
  };

  render() {
    const { slideCount, slidesToScroll, slidesToShow, cellAlign, currentSlide, className } = this.props;
    const indexes = this.getDotIndexes(slideCount, slidesToScroll as number, slidesToShow, cellAlign);
    return (
      <ListUl className={className}>
        {indexes.map((index) => {
          return (
            <ListLi key={index}>
              <Button
                active={currentSlide === index}
                onClick={this.goToSlide(index)}
                aria-label={`slide ${index + 1} bullet`}
              />
            </ListLi>
          );
        })}
      </ListUl>
    );
  }
}
